import React, { useState } from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import { FormLabel, Offcanvas } from 'react-bootstrap'
import { PanelFooter, PanelHeader } from 'components/Panel'
import FileUpload from 'components/FileUpload/FileUpload'

function NuevoEje(props) {
	const { guardar, setQueMostrar } = props

	const datosInicial = {
		nombre: '',
		orden: '',
        files: []
	}
	const [datos, setDatos] = useState(datosInicial)

	const handleClose = () => {
		setQueMostrar('')
		setDatos(datosInicial)
	}

	const handleProcesar = (e) => {
		e.preventDefault()

		const data = {
			...datos,
		}
		
		guardar(data)
		handleClose()
	}

	const handleChange = (value, key) => {
		const datosCopia = { ...datos }
		datosCopia[key] = value
		setDatos(prev => datosCopia)
	}
   
    const updateFoto = (files) => {
		if (files.length > 0) {
            const datosCopia = { ...datos }
            datosCopia.files = files
            setDatos(prev => datosCopia)
		} else {
			const datosCopia = { ...datos }
            datosCopia.files = []
            setDatos(prev => datosCopia)
		}
	}

	// render
	return (
		<Offcanvas show={true} onHide={handleClose} placement="end" scroll="true">
			<PanelHeader onClick={handleClose} iconClass="fa-arrow-left" btnText="Atrás" text="Nuevo eje" />
			<Offcanvas.Body>
				<h1>Datos del eje</h1>
				<Row>
					<Col sm={12} md={6}>
						<Form onSubmit={handleProcesar} className="ms-4">
							<Row>
								<Col>
									<Form.Group className="mb-3" controlId="eje-nombre">
										<FormLabel>Nombre</FormLabel>
										<Form.Control
											value={datos.nombre}
											type="text"
											onChange={(e) => handleChange(e.target.value, 'nombre')}
										/>
									</Form.Group>
								</Col>
							</Row>
							<Row>
								<Col>
									<Form.Group className="mb-3 col-md-3" controlId="eje-orden">
										<FormLabel>Orden</FormLabel>
										<Form.Control
											value={datos.orden}
											type="number"
											onChange={(e) => handleChange(e.target.value, 'orden')}
										/>
									</Form.Group>
								</Col>
							</Row>
                            <Row>
                                <Col>
                                    <Form noValidate>						
                                        <FileUpload
                                            updateFiles={updateFoto}
                                            title="Seleccionar foto"
                                            accept=".jpg,.jpeg,.png"
                                        />
                                    </Form>
                                </Col>
                            </Row>		
						</Form>
					</Col>
				</Row>
			</Offcanvas.Body>
			<PanelFooter>
				<Button variant="outline-tertiary" onClick={handleClose} className="me-2">
					Cancelar
				</Button>
				<Button variant="primary" onClick={handleProcesar}>
					Guardar
				</Button>
			</PanelFooter>
		</Offcanvas>
	)
}

export default NuevoEje